module.exports = __webpack_public_path__ + "laliga_square-0b6c39e74dc7a67bdc13d62eac876282.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/no/laliga_square.png
// module id = 1184
// module chunks = 1 2